<app-styled-banner [banner]='banner'></app-styled-banner>
<app-social-wall [instaPosts]="instaPosts" [fbPosts]="fbPosts"></app-social-wall>
